import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = { class: "flex justify-between mt-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selector = _resolveComponent("Selector")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: `Cambiar rol del usuario ${_ctx.user.user.firstName + ' ' + _ctx.user.user.lastName}`,
      onOnClose: _ctx.closeModal,
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = (e) => _ctx.showModal = e)
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editRol && _ctx.editRol(...args))),
            class: "px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600"
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Editar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Selector, {
            class: "w-full sm:w-full",
            items: _ctx.permissions,
            selectedItem: Number(_ctx.role),
            placeHolder: 'Rol del usuario',
            label: 'Selecciona el rol del usuario',
            onUpdate: _ctx.onUpdateRol
          }, null, 8, ["items", "selectedItem", "onUpdate"])
        ])
      ]),
      _: 1
    }, 8, ["title", "onOnClose", "visible"])
  ]))
}